import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_CRM_API_URL;

const axios = createAxiosInstance(URL);
export const fetchOrdersMonthStatisticId = (id) => {
    return axios.get(`/api/v1/orders/orders/${id}/statistic/`);
};

export const fetchOrderSchema = () => {
    return axios.get('/api/v1/orders/orders/schema/');
};

export const fetchCustomers = async () => {
    const { results } = await axios.get('/api/v1/customers/customers/?page_size=100');
    return results;
};

export const fetchCustomer = (id) => {
    if (!id) return;

    return axios.get(`/api/v1/customers/customers/${id}/`);
};

export const fetchProductionTypes = async () => {
    return axios.get('/api/v1/customers/customers/type_productions/');
};

export const fetchOrderTypes = async () => {
    return axios.get('/api/v1/orders/orders/type_orders/');
};

export const createOrder = (data) => {
    return axios.post('/api/v1/orders/orders/', data);
};

export const fetchOrders = async (params = { page: 1, page_size: 20 }) => {
    const { results = [], count, next } = await axios.get('/api/v1/orders/orders/', { params });

    return { results, count, next };
};

export const exportOrdersCsv = (params = {}) => {
    return axios.get('/api/v1/orders/orders/export_csv/', { params, responseType: 'blob' });
};

export const fetchStates = async () => {
    const { results = [] } = await axios.get('/api/v1/orders/orders_transitions/schema/');
    return results;
};

export const fetchGuestToken = async (orderId) => {
    return axios.post(`/api/v1/orders/orders/${orderId}/guest_token/`);
};

export const fetchOrder = (orderId) => {
    return axios.get(`/api/v1/orders/orders/${orderId}/`);
};

export const fetchOrderTransitionSchema = (transitionId, extraParams = {}) => {
    console.log(transitionId);
    return axios.get('/api/v1/orders/orders_transitions/schema/', {
        params: {
            object_id: transitionId,
            ...extraParams,
        },
    });
};

export const changeState = (orderId, data) => {
    return axios.post(`/api/v1/orders/orders/${orderId}/change_state/`, data);
};

export const updateOrder = (orderId, data) => {
    return axios.patch(`/api/v1/orders/orders/${orderId}/`, data);
};

export const fetchOrderHistory = async (orderId, params = {}) => {
    const { results } = await axios.get('/api/v1/orders/orders_transitions/', {
        params: {
            object_id: orderId,
            page_size: 50,
            ...params,
        },
    });

    return results;
};

export const fetchOrderTransitionActionState = async (transitionId, orderId, params = {}) => {
    const { results } = await axios.get('/api/v1/orders/orders_transition_action_states/', {
        params: {
            transition: transitionId,
            object_id: orderId,
            ...params,
        },
    });

    return results;
};

export const restartOrderTransitionAction = (orderId, action) => {
    return axios.post(`/api/v1/orders/orders/${orderId}/restart_transition_action/`, {
        transition_action: action,
    });
};

export const fetchOrderBuilds = (orderId) => {
    return axios.get(`/api/v1/orders/orders/${orderId}/builds/`);
};

export const createOrderBuilds = (orderId, data) => {
    return axios.post(`/api/v1/orders/orders/${orderId}/build/`, data);
};

export const checkOrderBuildsQueue = (orderId) => {
    return axios.get(`/api/v1/orders/orders/${orderId}/build_in_process/`);
};

export const fetchOrderNoteBuilds = (orderId, params = {}) => {
    return axios.get(`/api/v1/orders/orders/${orderId}/note_builds/`, { params });
};

export const createOrderNoteBuilds = (orderId, data) => {
    return axios.post(`/api/v1/orders/orders/${orderId}/note_build/`, data);
};

export const checkOrderNoteBuildsQueue = (orderId, params = {}) => {
    return axios.get(`/api/v1/orders/orders/${orderId}/note_build_in_process/`, { params });
};

export const fetchOrderStatistic = (orderId) => {
    return axios.get(`/api/v1/orders/orders/${orderId}/statistic/`);
};

export const fetchCustomerFlows = async (customerId, params = {}) => {
    params = {
        page_size: 199,
        customer: customerId,
        ...params,
    };

    if (!customerId) {
        delete params.id;
    }

    const { results = [] } = await axios.get('/api/v1/customers/flows/', {
        params,
    });
    return results;
};

export const fetchOrdersTabsSettings = (customerId, params = {}) => {
    return axios.get('/api/v1/orders/orders/tabs/', {
        params: {
            customer: customerId,
            ...params,
        },
    });
};

export const fetchOrderDefaultSpeakers = (orderId, params = {}) => {
    return axios.get(`/api/v1/orders/orders/${orderId}/default_speakers/`, { params });
};

export const createOrderComment = (orderId, data) => {
    return axios.post(`/api/v1/orders/orders/${orderId}/comments/`, data);
};

export const fetchOrderComments = (orderId = null, link = null, params = {}) => {
    if (orderId) return axios.get(`/api/v1/orders/orders/${orderId}/comments/`, { params });
    return axios.get(link, { params });
};
